import { Extension } from '@tiptap/core';
import {
    MatchingNode,
    MatchingNodeHeadless,
    MatchingPairDefinitionNode,
    MatchingPairDefinitionNodeHeadless,
    MatchingPairExplanationNode,
    MatchingPairExplanationNodeHeadless,
    MatchingPairNode,
    MatchingPairNodeHeadless,
    MatchingPairTermNode,
    MatchingPairTermNodeHeadless,
} from './matching-extension';

export const MatchingHeadless = Extension.create({
    name: 'matchingWrapper',

    addOptions() {
        return {};
    },

    addExtensions() {
        return [
            MatchingNodeHeadless,
            MatchingPairNodeHeadless,
            MatchingPairTermNodeHeadless,
            MatchingPairDefinitionNodeHeadless,
            MatchingPairExplanationNodeHeadless,
        ];
    },
});

export const Matching = MatchingHeadless.extend({
    addExtensions() {
        return [MatchingNode, MatchingPairNode, MatchingPairTermNode, MatchingPairDefinitionNode, MatchingPairExplanationNode];
    },
});

export default Matching;
